/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppBar, Button, IconButton, Toolbar, Hidden, colors } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import UserMenuPopover from '../UserMenuPopover';
import CompanyMenuPopover from '../CompanyMenuPopover';
import { AuthenLogout, SetCompanySelect } from 'store/actions';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const TopBar = props => {
  const { onOpenNavBarMobile, className, ...rest } = props;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const authen = useSelector(({ authen }) => authen);
  const company = useSelector(({ company }) => company);

  const companyMenuItemsRef = useRef(null);
  const webUserMenuItemsRef = useRef(null);
  const mobileUserMenuItemsRef = useRef(null);

  const [companyMenuIsVisible, setCompanyMenuIsVisible] = useState(false);
  const [openCompanyMenuPopover, setOpenCompanyMenuPopover] = useState(false);
  const [openWebUserMenuPopover, setOpenWebUserMenuPopover] = useState(false);
  const [openMoblieUserMenuPopover, setOpenMoblieUserMenuPopover] = useState(false);

  useEffect(() => {
    if (authen.isAuthenticated && authen.loginUser.role === 'super') {
      setCompanyMenuIsVisible(true);
    }
  }, [dispatch, authen]);

  const handleCompanyChange = value => {
    dispatch(SetCompanySelect(value));
    setOpenCompanyMenuPopover(false);
  };

  const handleLogout = () => {
    dispatch(AuthenLogout());
  };

  const handleRequestHelp = () => {
    history.push('help');
    setOpenWebUserMenuPopover(false);
    setOpenMoblieUserMenuPopover(false);
  };

  const handleChangePassword = () => {
    history.push('change-password');
    setOpenWebUserMenuPopover(false);
    setOpenMoblieUserMenuPopover(false);
  };

  const menuItems = [
    { id: 1, title: 'Request help', onClick: handleRequestHelp },
    { id: 2, title: 'Change password', onClick: handleChangePassword },
    { id: 3, title: 'Sign out', onClick: handleLogout }
  ];

  const handleCompanyMenuPopoverOpen = () => {
    setOpenCompanyMenuPopover(true);
  };

  const handleCompanyMenuPopoverClose = () => {
    setOpenCompanyMenuPopover(false);
  };

  const handleWebUserMenuPopoverOpen = () => {
    setOpenWebUserMenuPopover(true);
  };

  const handleWebUserMenuPopoverClose = () => {
    setOpenWebUserMenuPopover(false);
  };

  const handleMobileUserMenuPopoverOpen = () => {
    setOpenMoblieUserMenuPopover(true);
  };

  const handleMobileUserMenuPopoverClose = () => {
    setOpenMoblieUserMenuPopover(false);
  };

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
    >
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="PU123@144x.png"
            className={classes.pu123}
            src="/images/@Finsense/PU123@144x.png"
          />
        </RouterLink>
        <div className={classes.flexGrow} />

        {companyMenuIsVisible && (
          <Button
            color="inherit"
            onClick={handleCompanyMenuPopoverOpen}
            ref={companyMenuItemsRef}
          >
            {company.select.companyName}
            <ExpandMoreIcon className={classes.extendedIcon} />
          </Button>
        )}

        <Hidden mdDown>
          <Button
            className={classes.logoutButton}
            color="inherit"
            onClick={handleWebUserMenuPopoverOpen}
            ref={webUserMenuItemsRef}
          >
            {authen.loginUser && authen.loginUser.sub}
          </Button>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={handleMobileUserMenuPopoverOpen}
            ref={mobileUserMenuItemsRef}
          >
            <AccountCircleIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onOpenNavBarMobile}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
      <CompanyMenuPopover
        anchorEl={companyMenuItemsRef.current}
        companyChange={handleCompanyChange}
        menuitems={company.data}
        onClose={handleCompanyMenuPopoverClose}
        open={openCompanyMenuPopover}
      />
      <UserMenuPopover
        anchorEl={webUserMenuItemsRef.current}
        menuitems={menuItems}
        onClose={handleWebUserMenuPopoverClose}
        open={openWebUserMenuPopover}
      />
      <UserMenuPopover
        anchorEl={mobileUserMenuItemsRef.current}
        menuitems={menuItems}
        onClose={handleMobileUserMenuPopoverClose}
        open={openMoblieUserMenuPopover}
      />
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func
};

export default TopBar;

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  pu123: {
    width: 59,
    height: 45,
    marginTop: 10,
    marginBottom: 10
  },
  flexGrow: {
    flexGrow: 1
  },
  button: {
    margin: theme.spacing(1)
  },
  extendedIcon: {
    marginLeft: theme.spacing(1)
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit'
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit'
    }
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100
  },
  searchPopperContent: {
    marginTop: theme.spacing(1)
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  trialIcon: {
    marginRight: theme.spacing(1)
  },
  notificationsButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600]
  },
  logoutButton: {
    marginLeft: theme.spacing(1)
  },
  logoutIcon: {
    marginRight: theme.spacing(1)
  }
}));
